<div class="col-12 bg-th-white h90">

    <div class="top-menu bg-th-white  d-flex justify-content-end align-items-center flex-wrap">

        <div class="d-flex w-100 col-12 justify-content-between dirI align-items-center pe-2">

            <p class="text-center mt-2  f16 vazir mb-0 text-dark">

                <i class="fa fa-question-circle text-secondary me-1 pointer" (click)="guid()"></i>
                
                تعداد خودرو‌های تحت مدیریت شما :
                
                <!-- لیست خودرو‌ها  -->

                <span style="text-decoration: underline;" class="text-primary pointer" [routerLink]="['/carList']">
                    
                    {{ carNumber | faNum }}
                    
                    مورد 
                
                </span>
                            
            </p>

            <i class="fa fa-close text-danger fa-2x me-3 pointer" (click)="close()" *ngIf="!isDesktop"></i>

            <!-- <button class="btn btn-outline-dark my-0 py-0 f14" [routerLink]="['/carList']">

                تعداد کل : {{carNumber | faNum}}

            </button> -->

        </div>

        <div dir="rtl" class="w-100 text-center py-2 mt-2">

            <div class="btn-group" role="group">

                <input type="radio" class="btn-check" name="tiType" id="all-car" checked (change)="showOfficialCar(-1)" [checked]="!bOfficial">

                <label class="btn btn-outline-secondary" for="all-car"> <small>همه خودروها</small> </label>
              
                <input type="radio" class="btn-check" name="tiType" id="official-car" (change)="showOfficialCar(1)"  [checked]="bOfficial">

                <label class="btn btn-outline-success" for="official-car"> <small>خودروهای خدماتی</small> </label>

                <ng-container *ngIf="isHubConnect">

                    <input type="radio" class="btn-check" name="tiType" id="AlarmFeed" (change)="onAlarmFeed()"  [checked]="isAlarmFeed">
    
                    <label class="btn btn-outline-primary" for="AlarmFeed"> <small>وقایع خودروها</small> </label>

                </ng-container>
              
              </div>
            
        </div>

        <!-- جستجو بر اساس نام و پلاک -->

        <div class="d-flex justify-content-center w-100">

            <input type="text" id="input_KeyValue" placeholder="جستجو بر اساس نام و پلاک"  class="form-control w-75 text-center my-2 dirI" (keyup)="search($event.target)">

        </div>

        <!-- دکمه های رادیویی فعال , غیر فعال , .... -->

        <div class="d-flex col-12 justify-content-center gap-2 mt-2 flex-wrap dirI">

            <div class="form-check">

                <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" checked>

                <label class="m-0 f12" for="radio1">همه</label>

            </div>

            <div class="form-check">

                <input type="radio" class="form-check-input" id="radio2" name="optradio" value="option2">

                <label class="m-0 f12" for="radio2">فعال</label>

            </div>

            <div class="form-check">

                <input type="radio" class="form-check-input " id="radio3" name="optradio" value="option3">

                <label class="m-0 f12" for="radio3">غیر فعال</label>

            </div>

            <div class="form-check" *ngIf="acssess.bEnableGeoFance">

                <input type="radio" class="form-check-input" id="radio5" name="optradio" value="option5">

                <label class="m-0 f12" for="radio5">محدوده</label>

            </div>

            <!-- فیلتر بر اساس نوع خودرو -->

            <div class="col-9 my-2 d-flex gap-2 flex-row align-items-center">

                <i class="fa fa-filter text-dark" aria-hidden="true"></i>

                <select id="carGroup" [(ngModel)]="carGroupModel" class="form-select" (change)="carGroupChange($event.target)">

                    <option value="-1"> همه نوع خودرو </option>

                    <option *ngFor="let item of groupCar" value="{{item.tiMobileType}}">{{item.strComment}}</option>

                </select>

                <button title="خروجی اکسل" class="excel-export-btn-main" (click)="exportexcel()">
                    
                    <i  class="fa fa-file-excel-o fa-lg text-dark"></i></button>

            </div>

        </div>

    </div>

    <!-- اطلاعات خودرو -->

    <div class="text-start ">

        <div style="max-height:53vh; overflow-y: auto;overflow-x: hidden;">

            <!-- وقایع هاب -->

            <ng-container *ngIf="isAlarmFeed; else vehiclesList">

                <table class="table table-bordered dirI pointer" id="excel-table">

                    <thead class="">

                        <tr class="text-center" style="vertical-align: middle;">

                            <th scope="col-1">#</th>

                            <th class="">عملیات</th>

                            <th class="">عنوان</th>
                            
                            <th class="">زمان</th>

                        </tr>

                    </thead>

                    <tbody *ngFor="let item of visibleAlarms; let i = index;">

                        <tr class="text-center" style="vertical-align: middle;">

                            <th class=""> {{ i + 1 | faNum }} </th>

                            <td class=""> 

                                <i class="fa fa-circle text-success" (click)="openVehicleInfo(item)"></i>

                                <i class="fa fa-crosshairs fa-lg mx-2" aria-hidden="true" (click)="focusOnCurrentLocation(item)"></i>
                                
                            </td>

                            <td class="f12"> {{ item?.strMessage ?? 'نامشخض' }} </td>

                            <td class="f12"> {{ item.strDate | faNum }} <br> {{ item.strTime | faNum }} </td>

                        </tr>

                    </tbody>

                </table>

            </ng-container>

            <!-- لیست خودروها -->

            <ng-template #vehiclesList>

                <table class="table table-bordered dirI pointer" id="excel-table">
    
                    <thead class="">
    
                        <tr class="text-center" style="vertical-align: middle;">
    
                            <th scope="col-1">#</th>
    
                            <th scope="col">
                                
                                <span class="d-none">
    
                                    وضعیت
    
                                </span> 
                        
                            </th>
    
                            <th scope="col" (click)="sortByName()">
    
                                راننده
    
                                <i class="fa fa-sort" aria-hidden="true"></i>
    
                            </th>
    
                            <th scope="col-2" (click)="sortByDate()">
    
                                تاریخ
    
                                <i class="fa fa-sort" aria-hidden="true"></i>
    
                            </th>
    
                            <th scope="col-md-3" (click)="sortByStatus()">
    
                                <span class=""> وضعیت </span>
    
                                <i class="fa fa-sort" aria-hidden="true"></i>
    
                            </th>
    
                            <th class="d-none" scope="col">پلاک</th>
    
                            <th class="d-none" scope="col">Imei</th>
    
                            <th class="d-none" scope="col">حوزه خدمت</th>
    
                            <th class="d-none" scope="col">گروه خودرو</th>
    
                            <th class="d-none" scope="col">نوع خودرو</th>
    
                            <th class="d-none" scope="col">عرض جغرافیایی</th>
    
                            <th class="d-none" scope="col">طول جغرافیایی</th>
    
                        </tr>
    
                    </thead>
    
                    <tbody *ngFor="let item of filterItem;let i=index" id="row{{i}}" name="rowTable">
    
                        <tr style="vertical-align: middle;">
    
                            <th class="col-1 text-center" scope="row" (click)="select(i,item)">
                                
                                {{ i + 1 | faNum}}
                            
                            </th>
    
                            <!-- خودرو های اداری -->
    
                            <ng-container *ngIf="item.bOfficial;else elseTemplate;">
    
                                <!-- فعال -->
    
                                <ng-container *ngIf="item.tiOfficialStatus == 1">
    
                                    <td class="d-flex justify-content-center align-items-center flex-column ">
        
                                            <img *ngIf="acssess.bEnableGeoFance" title="تحلیل در محدوده " 
                                            
                                                class="pointer" width="22" height="22" 
                                                
                                                src="../../../assets/Img/polygon-icon-28-min.png" 
                                                
                                                (click)="openpolyganModal(item)">
                                                
        
                                            <i class="fa fa-circle text-success " 
                                            
                                                (click)="openDetailPage(item?.strUnitID ? item.strUnitID : item.strUnitId)"></i>
                                            
                                            <span class="d-none">فعال</span>
        
                                            <i (click)="viewSubDetails(i)" class="fa fa-eye"></i>                            
                                    </td>
        
                                </ng-container>
        
                                <!-- غیر فعال -->
        
                                <ng-container *ngIf="item.tiOfficialStatus == 0 || item.tiOfficialStatus == null ">
        
                                    <td class="d-flex justify-content-center align-items-center flex-column"> 
        
                                            <img *ngIf="acssess.bEnableGeoFance" title="تحلیل در محدوده " class="pointer" width="22" height="22" src="../../../assets/Img/polygon-icon-28-min.png" (click)="openpolyganModal(item)">
                                                
                                            <i class="fa fa-circle text-danger" (click)="openDetailPage(item?.strUnitID ? item.strUnitID : item.strUnitId)"> </i>
                    
                                            <span class="d-none">غیر فعال</span>
                    
                                            <i (click)="viewSubDetails(i)" class="fa fa-eye"></i>
        
                                    </td>
        
                                </ng-container>
    
                                <!--  -->
        
                                <ng-container *ngIf="item.tiOfficialStatus == 2">
        
                                    <td class="d-flex justify-content-center align-items-center flex-column"> 
        
                                            <img *ngIf="acssess.bEnableGeoFance" title="تحلیل در محدوده " class="pointer" width="22" height="22" src="../../../assets/Img/polygon-icon-28-min.png" (click)="openpolyganModal(item)">
                                                
                                            <i class="fa fa-circle text-primary" (click)="openDetailPage(item?.strUnitID ? item.strUnitID : item.strUnitId)"> </i>
                    
                                            <span class="d-none">غیر فعال</span>
                    
                                            <i (click)="viewSubDetails(i)" class="fa fa-eye"></i>
        
                                    </td>
        
                                </ng-container>
    
                            </ng-container>
    
                            <!-- همه خودروها -->
    
                            <ng-template #elseTemplate>
    
                                <!-- فعال -->
    
                                <ng-container *ngIf="item.bOnline && !item.bNoMobileHistory">
    
                                    <td class="d-flex justify-content-center align-items-center flex-column ">
        
                                            <img *ngIf="acssess.bEnableGeoFance" title="تحلیل در محدوده " 
                                            
                                                class="pointer" width="22" height="22" 
                                                
                                                src="../../../assets/Img/polygon-icon-28-min.png" 
                                                
                                                (click)="openpolyganModal(item)">
        
                                            <i class="fa fa-circle text-success " (click)="openDetailPage(item?.strUnitID ? item.strUnitID : item.strUnitId)"></i>
                                            
                                            <span class="d-none">فعال</span>
        
                                            <i (click)="viewSubDetails(i)" class="fa fa-eye"></i>                            
                                    </td>
        
                                </ng-container>
        
                                <!-- غیر فعال -->
        
                                <ng-container *ngIf="!item.bOnline && !item.bNoMobileHistory">
        
                                    <td class="d-flex justify-content-center align-items-center flex-column"> 
        
                                            <img *ngIf="acssess.bEnableGeoFance" title="تحلیل در محدوده " class="pointer" width="22" height="22" src="../../../assets/Img/polygon-icon-28-min.png" (click)="openpolyganModal(item)">
                                                
                                            <i class="fa fa-circle text-danger" (click)="openDetailPage(item?.strUnitID ? item.strUnitID : item.strUnitId)"> </i>
                    
                                            <span class="d-none">غیر فعال</span>
                    
                                                <i (click)="viewSubDetails(i)" class="fa fa-eye"></i>
        
                                    </td>
        
                                </ng-container>
    
                            </ng-template>
    
                            <td *ngIf="item.bNoMobileHistory">
                                
                                <i class="fa fa-circle text-warning"></i>
                                
                                <span class="d-none">بدون سابقه</span>
                            
                            </td> 
    
                            <td class="vazir col f12" (click)="select(i,item)">
                                
                                {{item.bOfficial ? item.strFullName2 : item.strFullName }}
                            
                            </td>
    
                            <td class="col-2 vazir f12 text-center" (click)="select(i,item)">
                                
                                {{item.strDate |faNum}}
    
                                {{item.strTime|faNum}}
                            
                            </td>
    
                            <td class="col-3 vazir text-center f12" (click)="select(i,item)">
                                
                                {{item.strDeviceStatus_strComment == '' ? ' - - - ' : item.strDeviceStatus_strComment}}
    
                            </td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.strVehicleNo}}</td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.strUnitId}}</td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.strMobileDomain_strComment}}</td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.strMobileGroup_strComment}}</td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.strMobileType_strComment}}</td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.fLat}}</td>
    
                            <td class="d-none" (click)="select(i,item)">{{item.fLon}}</td>
    
                            <!-- <td><i (click)="viewSubDetails(i)" class="fa fa-eye"></i></td> -->
    
                        </tr>
    
                        <tr>
                            <td colspan="12" [id]="'collapsible' + i" class="col-12 bg-white collapse">
    
                                <div class="d-flex flex-wrap justify-content-between mx-2 f14">
    
                                   <p> نوع : 
                                        
                                        <strong>{{item.strMobileType_strComment}}</strong>
                                    
                                    </p>
    
                                   <p> پلاک : 
                                        
                                        <strong>{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</strong>
    
                                    </p>
    
                                   <p> سرعت :
                                        
                                        <strong>{{item.iSpeed | faNum}}</strong>
                                        
                                        km/s
                                    
                                    </p>
    
                                    <i class="fa fa-caret-up fa-lg mt-2" (click)="viewSubDetails(i)"></i>
    
                                </div>
    
                            </td>
    
                        </tr>
    
                    </tbody>
    
                </table>

            </ng-template>

        </div>

        <div class="col-12 d-flex justify-content-around flex-wrap dirI pe-2">

            <p class="text-dark f14" *ngIf="filterItem">کل : <strong>{{filterItem.length|faNum}}</strong> مورد</p>

            <p class="text-success f14" *ngIf="onlineCar"> فعال : <strong>{{onlineCar.length |faNum}}</strong> مورد</p>

            <p class="text-danger f14" *ngIf="oflineCar"> غیر فعال : <strong>{{oflineCar.length|faNum}}</strong> مورد

            </p>


        </div>


    </div>

</div>